// web/src/lib/pdf.protocol.ts
// The wire protocol between the PDF worker and its client, plus the pure raster
// fidelity rule. One source of truth so the worker and client never drift.

/** MIME type used by the worker when encoding slide blobs. Declared here (not in
 *  pdf.ts) so the worker can import it without pulling in DOM-typed code. */
export const SLIDE_IMAGE_TYPE = "image/webp" as const;

export interface RenderedPagePayload {
  slideIndex: number;
  blob: Blob;
  width: number;
  height: number;
}

export type WorkerRequest =
  | { kind: "count"; id: number; pdf: ArrayBuffer }
  | { kind: "render"; id: number; pdf: ArrayBuffer; indices: number[]; scale: number };

export type WorkerReply =
  | { kind: "count"; id: number; pageCount: number }
  | { kind: "page"; id: number; page: RenderedPagePayload }
  | { kind: "done"; id: number }
  | { kind: "error"; id: number; message: string };

/**
 * Canvas size for a rendered page: the page's native viewport dimensions ceiled
 * to whole pixels. No fixed canvas, no letterbox — the raster is the page's
 * native aspect with zero padding, so a normalized box_2d maps onto it exactly.
 */
export function pageCanvasSize(
  viewportWidth: number,
  viewportHeight: number,
): { width: number; height: number } {
  return { width: Math.ceil(viewportWidth), height: Math.ceil(viewportHeight) };
}
